let pick_data2 = [
    {
        id : 80,
        imgurl : '/img/section7/section7_women1.jpg',
        brand : 'jsny',
        title : 'Cable-knit Sweater [Blue]',
        persent : '14%',
        price : '129,000',
        saleprice : '110,290',
    },
    {
        id : 81,
        imgurl : '/img/section7/section7_women2.jpg',
        brand : 'LOOKAST',
        title : '네이비 리즈 라인 니트 가디건',
        persent : '28%',
        price : '98,000',
        saleprice : '70,560',
    },
    {
        id : 82,
        imgurl : '/img/section7/section7_women3.jpg',
        brand : 'LOOKAST',
        title : '베이직 스트라이프 티셔츠',
        persent : '14%',
        price : '58,000',
        saleprice : '49,590',
    },
    {
        id : 83,
        imgurl : '/img/section7/section7_women4.jpg',
        brand : 'DAKS LADIES',
        title : '블랙 스트랩 5부소매원피스',
        persent : '20%',
        price : '355,000',
        saleprice : '282,270',
    },
    {
        id : 84,
        imgurl : '/img/section7/section7_women5.jpg',
        brand : 'BA&SH',
        title : '그린 패턴 5부소매원피스',
        persent : '24%',
        price : '498,000',
        saleprice : '378,480',
    },
    {
        id : 85,
        imgurl : '/img/section7/section7_women6.jpg',
        brand : 'JILLSTUART NEW YORK WOMEN',
        title : '네이비 빅카라 벨트 세트 원피스',
        persent : '5%',
        price : '629,000',
        saleprice : '597,550',
    },
    {
        id : 86,
        imgurl : '/img/section7/section7_women7.jpg',
        brand : 'DAKS LADIES',
        title : '블랙 솔리드 풀밴딩 와이드팬츠',
        persent : '20%',
        price : '175,000',
        saleprice : '139,150',
    },
    {
        id : 87,
        imgurl : '/img/section7/section7_women8.jpg',
        brand : 'TILLIDIE',
        title : 'Roll up shirt ops_Navy',
        persent : '15%',
        price : '169,000',
        saleprice : '143,650',
    }
]

export default pick_data2